import './App.css';
import Rutas from './router/App.Routes';
import Footer from './components/Footer/Footer.js';
import NavBar from './components/NavBar/NavBar';

function App() {
  return (
    <>
      <header>
        <link rel="icon" href="./img/logoCoop.png" />
      </header>
      <NavBar />
      <Rutas />
      <Footer />
    </>
  );
}

export default App;
